import React from 'react';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { PropTypes } from 'prop-types';
import treeChanges from 'tree-changes';

import { Card, Tabs, Tooltip, Spin } from 'antd';

import RtnRcptProcessActions from '../../Stores/RtnRcptProcess/Actions';

import GdsRcpt02Table from '../GdsRcpt02/GdsRcpt02Table';
import GdsRcpt0201Table from '../GdsRcpt0201/GdsRcpt0201Table';
import InvDoc02Table from '../InvDoc02/InvDoc02Table';
import WhseJob1402Table from '../WhseJob1402/WhseJob1402Table';
import WhseJob140201Table from '../WhseJob140201/WhseJob140201Table';
import PutAway02Table from '../PutAway02/PutAway02Table';
import WhseJob1502Table from '../WhseJob1502/WhseJob1502Table';
import WhseJob150201Table from '../WhseJob150201/WhseJob150201Table';

const { TabPane } = Tabs;

class RtnRcptProcessScreen extends React.PureComponent {
  componentDidMount() {
    const { curSiteFlowId, fetchRtnRcptProcess } = this.props;
    if (curSiteFlowId > 0) {
      fetchRtnRcptProcess();
    }
  }

  componentDidUpdate(prevProps) {
    const { curSiteFlowId, fetchRtnRcptProcess } = this.props;

    const { changed } = treeChanges(prevProps, this.props);

    if (changed('curSiteFlowId')) {
      if (curSiteFlowId > 0) {
        fetchRtnRcptProcess();
      }
    }
  }

  componentWillUnmount() {}

  render() {
    const { intl, match, process, appPath, processIsLoading } = this.props;

    return (
      <Card>
        <Spin spinning={processIsLoading}>
          <Tabs type="card" activeKey={match.params.proc_type}>
            {process.map(value => (
              <TabPane
                tab={
                  // eslint-disable-next-line react/jsx-wrap-multilines
                  <Tooltip
                    placement="bottom"
                    title={intl.formatMessage({ id: `${value.proc_type.toLowerCase()}_desc` })}
                  >
                    <Link
                      style={value.proc_type !== match.params.proc_type ? { color: 'black' } : {}}
                      to={`${appPath}/rtnRcptProcess/index/${value.proc_type}`}
                    >
                      <FormattedMessage id={`${value.proc_type.toLowerCase()}_label`} />
                    </Link>
                  </Tooltip>
                }
                key={value.proc_type}
              />
            ))}
          </Tabs>
        </Spin>

        {match.params.proc_type === 'GDS_RCPT_02' && <GdsRcpt02Table match={match} />}
        {match.params.proc_type === 'GDS_RCPT_02_01' && <GdsRcpt0201Table match={match} />}
        {match.params.proc_type === 'INV_DOC_02' && <InvDoc02Table match={match} />}
        {match.params.proc_type === 'WHSE_JOB_14_02' && <WhseJob1402Table match={match} />}
        {match.params.proc_type === 'WHSE_JOB_14_02_01' && <WhseJob140201Table match={match} />}
        {match.params.proc_type === 'PUT_AWAY_02' && <PutAway02Table match={match} />}
        {match.params.proc_type === 'WHSE_JOB_15_02' && <WhseJob1502Table match={match} />}
        {match.params.proc_type === 'WHSE_JOB_15_02_01' && <WhseJob150201Table match={match} />}
      </Card>
    );
  }
}

RtnRcptProcessScreen.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  match: PropTypes.object,
  appPath: PropTypes.string,
  process: PropTypes.arrayOf(PropTypes.object),
  processIsLoading: PropTypes.bool,

  curSiteFlowId: PropTypes.number,
  fetchRtnRcptProcess: PropTypes.func
};

RtnRcptProcessScreen.defaultProps = {
  intl: {},
  match: {},
  appPath: '',
  process: [],
  processIsLoading: false,

  curSiteFlowId: 0,
  fetchRtnRcptProcess() {}
};

const mapStateToProps = state => ({
  appPath: state.app.appPath,
  process: state.rtnRcptProcess.process,
  processIsLoading: state.rtnRcptProcess.processIsLoading,

  curSiteFlowId: state.app.curSiteFlowId
});

const mapDispatchToProps = dispatch => ({
  fetchRtnRcptProcess: () => dispatch(RtnRcptProcessActions.rtnRcptProcessFetchRtnRcptProcess())
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(RtnRcptProcessScreen));
